import { Injector } from "@angular/core";
import { QueryConditionsNode } from "../../QueryConditionsNode";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { BaseNode } from "../../BaseNode";

export class QueryConditionNodeInbox extends QueryConditionsNode {

  constructor(injector: Injector, queryConditions: FormlyFieldConfig[]) {
    super(injector, queryConditions);
  }
 
  override cloneNode(newParent: BaseNode): BaseNode {
    const clonedNode = new QueryConditionNodeInbox(this.ioc!, this.originalInfo.fields);
    clonedNode.parent = newParent;
    return clonedNode; 
  }

}